<section class="flex justify-content-center mt-4">
  <div class="card-table col-12">
    <app-dataset-visualizar-documentos></app-dataset-visualizar-documentos>

    <div *ngIf="loading" class="flex justify-content-center align-items-center" style="min-height: 400px;">
      <p-progressSpinner></p-progressSpinner>
    </div>

    <div *ngIf="perfil && !loading">
      <div>
        <h3 class="font-23 font-normal font-roboto-condensed title-blue uppercase mb-3">
          {{ 'common.perfil' | translate }}
        </h3>
      </div>

      <main class="grid formgrid p-fluid">
        <!-- Avatar y nombre completo -->
        <div class="field col-12">
          <div class="grid">
            <div class="col-12 sm:col-8 lg:col-9 pb-2 align-content-center">
              <div class="grid">
                <div class="col-3 sm:col-4 lg:col-3 xl:col-2">
                  <p-avatar size="xlarge" shape="circle" [label]="firstLetterName"
                    [style]="{'background-color': '#0A4360', 'color': '#ffffff'}"></p-avatar>
                </div>
                <div class="col-9 sm:col-6 lg:col-6 xl:col-7">
                  <label class="font-bold">
                    {{ 'common.nombreCompleto' | translate }}
                  </label>
                  <p class="font-16 font-normal my-1">{{ nombreCompleto ? nombreCompleto : 'N/A' }}</p>
                </div>
              </div>
            </div>
            <div class="col-12 sm:col-4 lg:col-3">
              <div class="flex-column gap-1 flex max-w-12rem align-items-center">
                <div class="puntaje">
                  {{ puntajeSisben ? puntajeSisben : 'N/A' }}
                </div>
                <label class="mt-1 mx-auto"> {{ 'common.puntajeSisben' | translate }} </label>
              </div>
            </div>
          </div>
          <p-divider class="col-12" />
        </div>

        <!-- Tipo de identificación -->
        <div class="field col-12 md:col-6 xl:col-6">
          <label class="font-bold">
            {{ 'common.tipoIdentificacion' | translate }}
          </label>
          <p class="font-16 font-normal my-1">{{ perfil.tipoIdentificacion ? perfil.tipoIdentificacion : 'N/A' }}</p>
        </div>

        <!-- Identificación -->
        <div class="field col-12 md:col-6 xl:col-6">
          <label class="font-bold">
            {{ 'common.identificacion' | translate }}
          </label>
          <p class="font-16 font-normal my-1">{{ perfil.identificacion ? perfil.identificacion : 'N/A' }}</p>
        </div>

        <!-- Fecha de expedición -->
        <div class="field col-12 md:col-6 xl:col-6">
          <label class="font-bold">
            {{ 'common.fechaExpedicion' | translate }}
          </label>
          <p class="font-16 font-normal my-1">{{ perfil.fechaExpedicion ? perfil.fechaExpedicion : 'N/A' }}</p>
        </div>

        <!-- Lugar de expedición -->
        <div class="field col-12 md:col-6 xl:col-6">
          <label class="font-bold">
            {{ 'common.lugarExpedicion' | translate }}
          </label>
          <p class="font-16 font-normal my-1">{{ perfil.lugarExpedicion ? perfil.lugarExpedicion : 'N/A' }}</p>
        </div>

        <!-- Género -->
        <div class="field col-12 md:col-6 xl:col-6">
          <label class="font-bold">
            {{ 'common.genero' | translate }}
          </label>
          <p class="font-16 font-normal my-1">{{ perfil.genero ? perfil.genero : 'N/A' }}</p>
        </div>

        <!-- Fecha de nacimiento -->
        <div class="field col-12 md:col-6 xl:col-6">
          <label class="font-bold">
            {{ 'common.fechaNacimiento' | translate }}
          </label>
          <p class="font-16 font-normal my-1">{{ perfil.fechaNacimiento ? perfil.fechaNacimiento : 'N/A' }}</p>
        </div>

        <!-- Dirección -->
        <div class="field col-12 md:col-6 xl:col-6">
          <label class="font-bold">
            {{ 'common.direccion' | translate }}
          </label>
          <p class="font-16 font-normal my-1">{{ perfil.direccion ? perfil.direccion : 'N/A' }}</p>
        </div>

        <!-- Barrio -->
        <div class="field col-12 md:col-6 xl:col-6">
          <label class="font-bold">
            {{ 'common.barrio' | translate }}
          </label>
          <p class="font-16 font-normal my-1">{{ perfil.barrio ? perfil.barrio : 'N/A' }}</p>
        </div>

        <!-- Correo Electrónico -->
        <div class="field col-12">
          <label class="font-bold">
            {{ 'common.correoElectronico' | translate }}
          </label>
          <p class="font-16 font-normal my-1">{{ perfil.correo ? perfil.correo : 'N/A' }}</p>
        </div>

        <!-- Teléfono móvil -->
        <div class="field col-12 md:col-6 xl:col-6">
          <label class="font-bold">
            {{ 'common.telefonoMovil' | translate }}
          </label>
          <p class="font-16 font-normal my-1">{{ perfil.telefonoMovil ? perfil.telefonoMovil : 'N/A' }}</p>
        </div>

        <!-- Teléfono fijo -->
        <div class="field col-12 md:col-6 xl:col-6">
          <label class="font-bold">
            {{ 'common.telefonoFijo' | translate }}
          </label>
          <p class="font-16 font-normal my-1">{{ perfil.telefonoFijo ? perfil.telefonoFijo : 'N/A' }}</p>
        </div>

        <!-- Documento de identificación - Botón descargar -->
        <div class="field col-12 md:col-6 xl:col-4">
          <label class="font-bold">
            {{ 'common.documentoIdentificacion' | translate }}
          </label>
          <button pButton type="button" [label]="'common.descargar' | translate"
            class="p-button-info p-button-outlined w-full" icon="pi pi-download" (click)="openDocuments()"></button>
        </div>
      </main>

      <p-divider class="my-4"></p-divider>

      <!-- Núcleo Familiar -->
      <div class="mt-4">
        <h4 class="font-20 font-normal font-roboto-condensed title-blue uppercase mb-3">
          {{ 'common.nucleoFamiliar' | translate }}
        </h4>
        <custom-table [config]="customTableNucleo" [rowExpansionTemplate]="nucleoRowExpansion">
        </custom-table>
        <ng-template #nucleoRowExpansion let-data>
          <app-nucleo-familiar-hijos [hijos]="data.hijos"
            class="app-card mx-auto border-1 border-top-none border-noround-top"></app-nucleo-familiar-hijos>
        </ng-template>
      </div>
    </div>
  </div>
</section>